import React from "react";

import SelectInput, { Result } from "../../../Inputs/SelectInput";
import { calculateQueryComparatorOptions } from "../../QueryBuilderUtils";

declare interface QueryComparatorProps {
	comparator: Result;
	onChange: (newComparator: Result) => void;
	fieldType?: string;
}

const QueryComparator = ({ comparator, onChange, fieldType = "text" }: QueryComparatorProps) => {
	const comparatorOptions = calculateQueryComparatorOptions(fieldType);
	return <SelectInput isSearchable={false} value={comparator} onChange={onChange} results={comparatorOptions} />;
};

export default QueryComparator;
